<template>
  <div class="snapshot__wrap">
    <div class="snapshot">
      <div class="tab">

        <span
            class="tab_title"
            :class="{ active : block==='MainInfo'}"
            @click="selected_block('MainInfo')">
            {{this.translate('snapshot.info')}}
          </span>
        <span
            class="tab_title"
            :class="{ active : block==='Config'}"
            @click="selected_block('Config')">
            {{this.translate('snapshot.config')}}
          </span>
        <span
            class="tab_title"
            :class="{ active : block==='Modems'}"
            @click="selected_block('Modems')"
        >
            {{this.translate('snapshot.modems')}}
          </span>

<!--        <span-->
<!--            class="tab_title"-->
<!--            :class="{ active : block==='MiniMaps'}"-->
<!--            @click="selected_block('MiniMaps')"-->
<!--        >-->
<!--            {{this.translate('snapshot.map')}}-->
<!--          </span>-->
      </div>

      <div class="block">
        <Config
          v-if="block==='Config'"
          :config="config"
        />
        <MainInfo
          v-if="block==='MainInfo'"
          :info="main_info"
        />
        <Modems
          v-if="block==='Modems'"
          :modems="modems"
        />
<!--        <MiniMaps-->
<!--          v-if="block==='MiniMaps'"-->
<!--          :factorytest_list="factorytest_list"-->
<!--        />-->
      </div>
    </div>
    <div class="text-center">
      <button
          class="btn btn-danger btn-fill btn-wd marginButton"
          @click.prevent="close"
      >
        {{ translate('close_modal') }}
      </button>
    </div>
  </div>
</template>
<script>

import Config from "@/views/Dashboard/common/Device/Device/SelfTest/SnapshotsModal/Config.vue";
import MainInfo from "@/views/Dashboard/common/Device/Device/SelfTest/SnapshotsModal/MainInfo.vue";
import Modems from "@/views/Dashboard/common/Device/Device/SelfTest/SnapshotsModal/Modems.vue";
// import MiniMaps from "@/views/Dashboard/common/Device/Device/SelfTest/SnapshotsModal/MiniMaps.vue";

export default {
  name: 'SnapshotsModal',
  props: ['data'],
  components: {
    Config,
    MainInfo,
    Modems,
    // MiniMaps
  },
  data () {
    return {
      snapshot_info: {},
      block: 'MainInfo',
    }
  },
  computed:{
    main_info(){
      let info = {...this.snapshot_info}
      delete(info.config)
      delete (info.modems)
      return info
    },
    config(){
      return JSON.stringify(this.snapshot_info.config)
    },
    modems(){
      return this.snapshot_info.modems
    }
  },
  created() {
    this.get_device_snapshot()
  },
  methods: {
    selected_block(block){
      this.block = block
    },
    get_device_snapshot() {
      this.$http.v1.getDeviceSnapshot( this.data.id, (response) => {
        this.snapshot_info = response.data
      })
    },
    close () {
      this.$emit('close')
    },
  }
}

</script>

<style lang='scss'>
.snapshot{
  height: 100%;
  &__wrap{
    height: 100%;
    padding: 10px;
  }
  .tab{
    width: 100%;
    height: 5%;
    display: flex;
    align-content: center;
    justify-content: center;
    flex-direction: row;
    &_title{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      padding: 5px 0;
      cursor: pointer;
      font-weight: 600;
      font-size: 14px;
      text-align: center;
      background-color: #efe9e9;
      border: 1px solid #efe9e9;
      &.active{
        background-color: white;
        border-bottom: 1px solid white;
      }
    }
  }
  .block{
    height: 95%;
    border: 1px solid #efe9e9;
    margin-top: -1px;
    padding: 10px;
    overflow: auto;
    &::-webkit-scrollbar{
      width: 10px;
    }
  }
}

</style>
